import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

//bootstrap
import { Form, Row, Col } from 'react-bootstrap'

// components
import DropDown from '../../components/dropdown/DropDown'

import NumBox from '../../components/atom/numBox/NumBox'
import BoxShadow from '../../components/atom/boxShadow/BoxShadow'
import ItemMenu from '../../components/itemMenu/ItemMenu'
import MoItemMenu from '../../components/moItemMenu/MoItemMenu'
import Button from '../../components/atom/button/Button'
import SearchIcon from '../../assets/image/search/ic-search.svg'
import { ScrollButton, HeaderTab } from '../../components'
import Empty from '../../pages/reviewList/components/Empty'
import Loading from '../../components/atom/loading/Loading'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import { useAxios } from '../../utils/useAxios'
import colors from '../../styles/colors'
import theme from '../../styles/theme'
import { set } from 'date-fns'

const ItemList = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const {
    fetchData: fetchGetData,
    loading: getLoading,
    data: getData,
    error: getError,
  } = useAxios()

  const {
    fetchData: fetchPostData,
    loading: postLoading,
    data: postData,
    error: postError,
  } = useAxios()

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480)
  const [isInit, setInit] = useState(true)

  const [products, setProducts] = useState([]) // (data) in itemList
  const [product, setProduct] = useState([]) // (data) out itemList(상품)

  const [countAll, setCountAll] = useState(0) // 상품 전체 갯수
  const [countNonsale, setCountNonsale] = useState(0) // 비판매(Y)
  const [countSale, setCountSale] = useState(0) // 판매(Y)

  const [promotionOption, setPromotionOption] = useState(['전체'])
  const [promotionStatus, setPromotionStatus] = useState('전체') // 프로모션 값

  const nonsaleObj = {
    A: '전체',
    N: '판매중',
    Y: '숨김',
  }
  const nonsaleOptions = Object.values(nonsaleObj)
  const [nonsaleStatus, setNonsaleStatus] = useState('A') // 판매상태 값
  const [chkNon, setChkNon] = useState(false)

  // 체크박스 아이템
  const [checkedItems, setCheckedItems] = useState([])

  // loading
  const [loading, setLoading] = useState(true)

  // request 값 (판매중/숨김/검색)
  const [saleItems, setSaleItems] = useState([])
  const [nonsaleItems, setNonSaleItems] = useState([])
  const [searchKeyword, setSearchKeyword] = useState('')

  // API 호출(목록)
  const getItems = async (nonsaleStatus) => {
    const params = {
      nonSale: nonsaleStatus,
      orderType: 'D',
      searchKeyword: searchKeyword,
    }

    fetchGetData(constants.API.PRODUCTS, 'GET', null, params)
    // setInit(false)
  }

  // API : 상품 판매/비판매 상태 변경
  const postSaleItem = (updatedSaleItems, updatedNonSaleItems) => {
    const reqData = {
      saleItems: updatedSaleItems,
      nonsaleItems: updatedNonSaleItems,
    }

    fetchPostData(constants.API.PRODUCTS, 'POST', reqData)

    setSaleItems([])
    setNonSaleItems([])
  }

  // 상태 조회 버튼(filter: 카테고리, 판매중/숨김)
  const handleSearchClick = () => {
    getItems(nonsaleStatus)
    setChkNon(true)
    // setInit(false)
  }

  // Mobile 화면에 따른 data 호출
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 480)
  }

  useEffect(() => {
    // window.addEventListener('load', onScrollHeight)
    window.addEventListener('resize', handleResize)

    return () => {
      // window.removeEventListener('load', onScrollHeight)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    getItems(nonsaleStatus)
    setProducts(getData?.resultData?.itemList)
    // setInit(true)
  }, [])

  // 상품 조회 api 호출 성공시
  useEffect(() => {
    if (
      getData?.responseCode === TYPE.API_RESPONSE.SUCCESS &&
      getData?.responseData &&
      getData?.responseData?.itemList
    ) {
      // 처음 받은 itemList를 저장 => 카테고리(프로모션) dropdown 저장
      const initialProducts = getData.responseData.itemList
      setProducts(initialProducts)
      setLoading(false)
      // setInit(false)

      // product (in itemList) set
      const newProduct = initialProducts.flatMap((items, index) =>
        items.itemList?.map((item, i) => item),
      )
      setProduct(newProduct)
      // console.log(' initialProducts', initialProducts)

      // 중복된 categoryName 처리
      // const uniqueCategoryNames = Array.from(
      //   new Set(newProduct.map((items) => items.categoryList[0].categoryName)),
      // )
      const uniqueCategoryNames = initialProducts.map((x) => x.categoryName)
      // console.log('uniqueCategoryNames', uniqueCategoryNames)
      const newPromotionOption = ['전체', ...uniqueCategoryNames]

      // 숨김 처리 갯수
      const countN = newProduct.reduce((count, item) => {
        if (item.saleYn === 'N') {
          return count + 1
        }
        return count
      }, 0)

      setCountAll(newProduct?.length)
      setCountNonsale(countN)
      setPromotionOption(newPromotionOption)

      const filteredProducts = newProduct?.filter((item) => {
        if (promotionStatus === '전체') {
          // 전체 카테고리를 선택한 경우 모든 상품 반환
          return true
        }
        // 선택한 카테고리와 일치하는 상품만 반환
        return item.categoryList[0]?.categoryName === promotionStatus
      })

      if (promotionStatus === '전체') {
        setProduct(newProduct)
      } else {
        setProduct(filteredProducts)
      }
    }
    setLoading(false)
    // setInit(false)
  }, [getData])

  // 상품 상태 변경(판매/비판매) 성공시
  useEffect(() => {
    if (postData?.responseCode === TYPE.API_RESPONSE.SUCCESS) {
      setCheckedItems([])
      getItems(nonsaleStatus)
    }
  }, [postData])

  // 상품 상태 변경(판매/비판매) api 호출
  useEffect(() => {
    if (saleItems.length > 0 || nonsaleItems.length > 0) {
      postSaleItem(saleItems, nonsaleItems)
    }
  }, [saleItems, nonsaleItems])

  return (
    <>
      <ItemListWrap>
        <article className="mb-4">
          <div>
            <HeaderTit>우리매장은</HeaderTit>
            <HeaderTxt>
              <span className="totalTxt">{countAll}개의</span>
              상품이 등록되어 있습니다.
            </HeaderTxt>
          </div>
        </article>
        <BoxShadow className="mb-4 d-flex flex-row align-items-center justify-items-center gap-5">
          <div className="col">
            <div className="row">
              <h4 className="mb-3 fs-6 fw-bold">메뉴상태</h4>
              <NumBox
                className="col"
                title={'전체'}
                num={countAll}
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'판매중'}
                num={countAll - countNonsale}
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'숨김'}
                num={countNonsale}
                unit={'개'}
              />
            </div>
          </div>
        </BoxShadow>
        <BoxShadow className={'mb-5'}>
          <h4 className="mb-4 fs-6 fw-bold">{promotionStatus}</h4>
          <Row>
            <DropDownCol lg={3} md={6} xs={6}>
              <DropDown
                className="mx-1"
                defaultOption="카테고리"
                options={promotionOption}
                setOption={setPromotionStatus}
                value={promotionStatus}
              />
            </DropDownCol>
            <DropDownCol lg={3} md={6} xs={6} className="me-1">
              <DropDown
                className="mx-1"
                defaultOption="판매상태"
                options={nonsaleOptions}
                setOption={(value) => {
                  const key = Object.keys(nonsaleObj).find(
                    (k) => nonsaleObj[k] === value,
                  )
                  setNonsaleStatus(key)
                }}
                value={nonsaleObj[nonsaleStatus]}
              />
            </DropDownCol>
            <DropDownCol lg={4} xs={12}>
              <StyledInput
                type="text"
                placeholder="상품명 검색"
                onChange={(e) => setSearchKeyword(e.target.value)}
              />
            </DropDownCol>
            <Col className="justify-content-end d-flex">
              <SearchIconBtn>
                <button type="button" onClick={handleSearchClick}>
                  <img src={SearchIcon} alt="검색버튼" />
                </button>
              </SearchIconBtn>
            </Col>
          </Row>
          <SearchBtn>
            <Button onClick={handleSearchClick}>조회</Button>
          </SearchBtn>
        </BoxShadow>
        <ReponsiveWrap>
          {isMobile ? (
            <div className="mobile-content">
              <MoItemMenu
                dataItems={products}
                dataItem={product}
                checkedItems={checkedItems}
                setCheckedItems={setCheckedItems}
                saleItems={saleItems}
                setSaleItems={setSaleItems}
                nonsaleItems={nonsaleItems}
                setNonSaleItems={setNonSaleItems}
                postSaleItem={postSaleItem}
                isInit={isInit}
                getLoading={products ? false : getLoading}
              />
            </div>
          ) : (
            <div className="desktop-content ">
              <ItemMenu
                dataItems={products}
                dataItem={product}
                chkNon={chkNon}
                checkedItems={checkedItems}
                setCheckedItems={setCheckedItems}
                saleItems={saleItems}
                setSaleItems={setSaleItems}
                nonsaleItems={nonsaleItems}
                setNonSaleItems={setNonSaleItems}
                postSaleItem={postSaleItem}
                isInit={isInit}
                getLoading={products ? false : getLoading}
              />
            </div>
          )}
        </ReponsiveWrap>
      </ItemListWrap>
    </>
  )
}

export default ItemList

const ItemListWrap = styled.section`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
const HeaderTit = styled.h4`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.BK};
  margin-bottom: 14px;
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const HeaderTxt = styled.p`
  font-size: 30px;
  font-weight: 700;
  color: ${colors.BK};
  .totalTxt {
    color: ${colors.mainG};
    margin-right: 10px;
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 20px;
  }
`
const SearchIconBtn = styled.div`
  margin: 0;
  padding: 0;
  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`
// 조회 버튼
const SearchBtn = styled.div`
  display: none;
  margin-top: 16px;
  @media ${(props) => props.theme.mobile} {
    display: block;
  }
`

const ReponsiveWrap = styled.div`
  .mobile-content {
    @media ${(props) => props.theme.desktop} {
      display: none;
    }
    @media ${(props) => props.theme.mobile} {
      display: block;
    }
  }
  .desktop-content {
    @media ${(props) => props.theme.desktop} {
      display: block;
    }
    @media ${(props) => props.theme.mobile} {
      display: none;
    }
  }
`
const StyledInput = styled(Form.Control)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  width: 100%;
  height: 48px;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  border: 1px solid rgb(229, 229, 229);
  /* &::placeholder {
    color: rgb(0, 0, 0);
  } */
  &:focus {
    outline: none;
    box-shadow: none;
    border: 1px solid rgb(229, 229, 229);
  }

  @media ${(props) => props.theme.tablet} {
    height: 48px;
    margin-left: 3px;
    margin-right: 3px;
  }
  @media ${(props) => props.theme.mobile} {
    height: 36px;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
  }
`
const DropDownCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
  @media ${(props) => props.theme.tablet} {
    margin-right: 0 !important;
    margin-bottom: 10px;
  }
  @media ${(props) => props.theme.mobile} {
    margin-right: 0 !important;
    margin-bottom: 10px;
  }
`
